// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const productSpecKeys = {
  all: ['productSpec'] as const,
  search: (category: string, searchTerm?: string) =>
    [...productSpecKeys.all, 'search', category, searchTerm] as const,
};

export default productSpecKeys;
